import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllServices } from "../../Api";

const ServicesCard = ({ language = "EN" }) => {

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const langKey = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title1: "Tailored",
      title2: "solutions",
      title3: "for every stage of life.",
      desc:
        "We put our clients first. Every recommendation we make is built around your unique circumstances, priorities, and ambitions — not a standard package. Explore our full range of services below.",
    },

    zh: {
      title1: "量身定制的",
      title2: "解决方案",
      title3: "适用于人生的每个阶段",
      desc:
        "我们始终以客户为中心。每一个建议都基于您的需求与目标，而不是固定方案。探索我们完整的服务范围。",
    },
  };


  useEffect(() => {
    getAllServices()
      .then((res) => {
        if (res.data.success) {
          setServices(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error("Services Fetch Error:", err);
      })
      .finally(() => setLoading(false));
  }, []);



  if (loading) {
    return (
      <section className="bg-white mt-10 mb-10">
        <div className="max-w-[1320px] mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(6)].map((_, i) => (
              <div
                key={i}
                className="h-[300px] bg-gray-200 animate-pulse rounded"
              ></div>
            ))}
          </div>
        </div>
      </section>
    );
  }



  return (
    <section className="bg-white mt-10 mb-10">
      <div className="max-w-[1320px] mx-auto px-4">

        {/* Heading */}
        <div className="max-w-3xl mx-auto mb-10 text-center">

          <h2 className="text-[34px] font-medium text-[#154059] leading-snug">

            {text[langKey].title1}{" "}
            <span className="text-[#C69C6D]">
              {text[langKey].title2}
            </span>{" "}
            {text[langKey].title3}

          </h2>

          <p className="text-gray-600 mt-5 leading-relaxed text-[15px]">
            {text[langKey].desc}
          </p>

        </div>



        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">

          {services.map((item) => {

            const shortText =
              item?.content?.[langKey]?.[0]?.slice(0, 120) || "";

            return (

              <div
                key={item._id}
                className="relative overflow-hidden group "
              >

                <img
                  src={`${process.env.REACT_APP_API_URL}/${item.image}`}
                  alt={item.title?.[langKey]}
                  className="w-full h-[300px] object-cover group-hover:scale-105 transition duration-500"
                />

                <div className="absolute inset-0 bg-gradient-to-r from-[#154059]/80 to-[#154059]/30"></div>

                <div className="absolute inset-0 p-8 text-white flex flex-col justify-end">

                  <Link to={`/services/${item._id}`}>

                    {item.icon && (
                      <img
                        src={`${process.env.REACT_APP_API_URL}/${item.icon}`}
                        alt=""
                        className="w-9 h-9 mb-4 brightness-0 invert"
                      />
                    )}

                    <h3 className="text-2xl font-semibold mb-3">
                      {item.title?.[langKey]}
                    </h3>

                    <p className="text-sm text-gray-200">
                      {shortText}...
                    </p>

                  </Link>

                </div>

              </div>

            );
          })}

        </div>

      </div>
    </section>
  );
};

export default ServicesCard;